<template>
  <div class="training-detail">
    <h2 class="class-title">{{ classInfo.className }}</h2>
    <table-list
      title=""
      :back-btn="{ name: '返回', method: handleBack }"
      :loading="loading"
      :search-form="searchForm(this)"
      :data="dataList"
      :columns="columns(this)"
      :btns="btns(this)"
      :pager="pager"
      :options="{ selection: false }"
      @search="onSearch"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
  </div>
</template>

<script>
const searchForm = () => [
  {
    label: '学员名称',
    prop: 'studentName',
  },
  {
    label: '学员手机号',
    prop: 'phone',
  },
]

const btns = _this => [
  {
    label: '个人学习详情',
    method: _this.handlePersonalDetail,
  },
  {
    label: '导出学习记录',
    method: _this.handleExport,
  },
]

const columns = _this => [
  {
    prop: 'studentName',
    label: '学员名称',
    minWidth: 100,
    render: (h, { row }) => {
      return h(
        'a',
        {
          style: { color: '#409EFF', cursor: 'pointer' },
          on: {
            click: () => _this.goStudentDetail(row),
          },
        },
        row.studentName,
      )
    },
  },
  {
    prop: 'phone',
    label: '手机号',
    minWidth: 120,
  },
  {
    prop: 'idCard',
    label: '身份证号',
    minWidth: 160,
    formatter: row => row.idCard || '-',
  },
  {
    prop: 'studyTimeRange',
    label: '学习开始/完成时间',
    minWidth: 200,
    render: (h, { row }) => {
      return h('div', [
        h('div', `开始：${row.studyBeginTime || '-'}`),
        h('div', `结束：${row.studyEndTime || '-'}`),
      ])
    },
  },
  {
    prop: 'studyDurationSum',
    label: '已学时长（分钟）',
    minWidth: 140,
  },
  {
    prop: 'courseDurationSum',
    label: '应学时长（分钟）',
    minWidth: 140,
  },
  {
    prop: 'completedSectionCount',
    label: '已学章节数',
    minWidth: 100,
  },
  {
    prop: 'sectionTotal',
    label: '应学章节数',
    minWidth: 100,
  },
  {
    prop: 'progress',
    label: '学习进度',
    minWidth: 100,
  },
]

const Exportcolumn = () => [
  { prop: 'studentName', label: '学员名称' },
  { prop: 'phone', label: '手机号' },
  { prop: 'idCard', label: '身份证号' },
  { prop: 'studyBeginTime', label: '学习开始时间' },
  { prop: 'studyEndTime', label: '学习完成时间' },
  { prop: 'studyDurationSum', label: '已学时长（分钟）' },
  { prop: 'courseDurationSum', label: '应学时长（分钟）' },
  { prop: 'completedSectionCount', label: '已学章节数' },
  { prop: 'sectionTotal', label: '应学章节数' },
  { prop: 'progress', label: '学习进度' },
]

import TableList from '@/components/TableList'
import to from 'await-to'
import { classCertInfo, classCertStudentStudyHistory } from '@/api/certificate'

export default {
  name: 'TrainingManageDetail',
  components: {
    TableList,
  },
  data() {
    return {
      searchForm,
      btns,
      columns,
      classInfo: {},
      loading: false,
      dataList: [],
      queryParams: {},
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
    }
  },
  computed: {
    classCertId() {
      return this.$route.params.classCertId
    },
  },
  mounted() {
    this.getClassInfo()
    this.getList()
  },
  methods: {
    async getClassInfo() {
      const [res, err] = await to(classCertInfo({ classCertId: this.classCertId }))
      if (err) return this.$message.warning(err.msg)
      this.classInfo = res.data
    },
    async getList() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(
        classCertStudentStudyHistory({
          classCertId: this.classCertId,
          current,
          size,
          ...this.queryParams,
        }),
      )
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.dataList = res.data.list
      this.pager.total = res.data.total
    },
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      this.getList()
    },
    goStudentDetail(row) {
      this.$router.push({
        path: `/certificate/trainingManage/studentDetail/${this.classCertId}`,
        query: { userId: row.userId },
      })
    },
    handlePersonalDetail() {
      this.$router.push(`/certificate/trainingManage/studentDetail/${this.classCertId}`)
    },
    handleExport() {
      if (!this.dataList.length) return this.$message.warning('暂无数据可导出')
      const allColumns = Exportcolumn()
      const tHeader = allColumns.map(c => c.label)
      const filterVal = allColumns.map(c => c.prop)
      const list = this.dataList
      require.ensure([], () => {
        const { export_json_to_excel } = require('@/vendor/Export2Excel')
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, `${this.classInfo.className || '培训'}学习记录`)
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    handleBack() {
      this.$router.back()
    },
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
.training-detail {
  padding: 20px;

  .class-title {
    font-size: 20px;
    font-weight: 500;
    margin: 0 0 16px;
  }

  ::v-deep.table-list .backBtn {
    margin-left: 0 !important;
    height: 40px;
  }
}
</style>
